/**
 * Toppe all'incolla delle tabelle dentro Quill.
 *
 * Quill riconosce come "riga di testo" i tag `td` e `tr` ma non `th`
 * (`quill/modules/clipboard.js`, funzione `isLine`): senza a capo fra una
 * intestazione e l'altra, tutte le intestazioni copiate da ChatGPT finiscono
 * in una cella sola, la prima a sinistra. Stessa origine lo spazio che
 * comparirebbe davanti alla prima cella del corpo: il testo di spaziatura fra
 * `</thead>` e `<tbody>` non viene scartato perche' nemmeno quei tag sono
 * righe per Quill.
 */
import Delta from 'quill-delta';

/** Tag che contengono celle, e fra i quali il testo e' solo impaginazione. */
const CONTENITORI_DI_CELLE = ['TABLE', 'THEAD', 'TBODY', 'TFOOT', 'TR'];

/**
 * Chiude l'intestazione come fosse una cella normale.
 *
 * Il grassetto e' il solo modo di distinguerla dopo: Quill non ha un blot per
 * `th` e salva ogni cella come `td`.
 */
export function cellaDiIntestazione(node: Node, delta: Delta): Delta {
  const operazioni = delta.ops ?? [];
  const inGrassetto = new Delta(
    operazioni.map((operazione) =>
      typeof operazione.insert === 'string'
        ? { ...operazione, attributes: { ...operazione.attributes, bold: true } }
        : operazione
    )
  );

  const ultima = operazioni[operazioni.length - 1];
  const giaChiusa = typeof ultima?.insert === 'string' && ultima.insert.endsWith('\n');
  // L'a capo resta senza attributi: in Quill segna la fine della cella, non e'
  // testo da formattare.
  return giaChiusa ? inGrassetto : inGrassetto.insert('\n');
}

/** Butta via il testo di sola spaziatura che sta fra una cella e l'altra. */
export function spaziaturaFraLeCelle(node: Node, delta: Delta): Delta {
  const genitore = node.parentElement?.tagName ?? '';
  const soloSpazi = (node.textContent ?? '').trim().length === 0;
  return CONTENITORI_DI_CELLE.includes(genitore) && soloSpazi ? new Delta() : delta;
}

/** Da passare a `clipboard.matchers` nei moduli dell'editor. */
export function matcherTabelleIncollate(): [string | number, (node: Node, delta: Delta) => Delta][] {
  return [
    ['th', cellaDiIntestazione],
    [Node.TEXT_NODE, spaziaturaFraLeCelle],
  ];
}
